import {useEffect} from 'react'
import {usePageTitle} from './PageTitleContext'

const PageTitle = ({children, subTitle}) => {
  const {setPageTitle, setPageSubTitle} = usePageTitle()

  useEffect(() => {
    setPageTitle(children)
    return () => {
      setPageTitle('')
    }
  }, [children, setPageTitle])

  useEffect(() => {
    setPageSubTitle(subTitle || '')
    return () => {
      setPageSubTitle('')
    }
  }, [subTitle, setPageSubTitle])

  return null
}

export default PageTitle
